import {useHttpClient} from '@raison/network-facade';
import {useState} from 'react';
import {ShellVersion} from '~/entities/versions';
import {addNewCard as addNewCardRequest} from '~/processes/cards';
import {isIOS} from '~/shared/utils/mobileDeviceDetect';

export type Options = {
    onSuccess?: () => void;
    onError?: (error: string) => void;
};

export function checkNativeStripeAvailability() {
    const {getFromWindow, parseAssert, compare} = ShellVersion;
    const current = getFromWindow();
    const target = parseAssert('2025.0');
    return isIOS() && current && compare(current, '>', target);
}

export const useAddNewCardIOS = (options?: Options) => {
    const cbName = 'stripeAddNewCardCallback';
    const [isPending, setIsPending] = useState(false);
    const http = useHttpClient();

    const addNewCard = async () => {
        setIsPending(true);
        const response = await addNewCardRequest(http);

        if (response.status === 'Abort') {
            throw response.reason;
        }

        (window as any)[cbName] = (result: {success: true} | {success: false; error: string}) => {
            if (result.success) {
                options?.onSuccess?.();
            } else {
                options?.onError?.(result.error);
            }
            setIsPending(false);
            delete (window as any)[cbName];
        };

        window.location.href = `gonative://stripe/setup?secret=${response.json.client_secret}&callbackFunction=${cbName}`;
    };

    return {addNewCard, isPending};
};

export const createPaymentIOS = (secret: string, payment_method: string) => {
    const cbName = 'stripeCreatePaymentCallback';
    const p = Promise.withResolvers<void>();
    (window as any)[cbName] = (result: {success: true} | {success: false; error: string}) => {
        if (result.success) {
            p.resolve();
        } else {
            p.reject(result.error);
        }
        delete (window as any)[cbName];
    };
    window.location.href = `gonative://stripe/payment?secret=${secret}&payment_method=${payment_method}&callbackFunction=${cbName}`;
    return p.promise;
};
